module.exports = __webpack_public_path__ + "media/images/media/media3-ce030b8631e9c84b831255ec6fd52e74.jpg";